import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_3 = { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }
const _hoisted_4 = { class: "pt-0 capitalize" }
const _hoisted_5 = { class: "pt-0 capitalize" }
const _hoisted_6 = {
  key: 0,
  class: "px-2 mt-1 text-sm text-white rounded-full bg-green w-fit"
}
const _hoisted_7 = {
  key: 1,
  class: "px-2 mt-1 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_8 = { class: "pt-0 capitalize" }
const _hoisted_9 = { class: "pt-0 capitalize" }
const _hoisted_10 = { class: "pt-0 capitalize" }
const _hoisted_11 = { class: "pt-0 capitalize" }
const _hoisted_12 = { class: "pt-0 capitalize" }
const _hoisted_13 = { class: "pt-0 capitalize" }
const _hoisted_14 = { class: "pt-0 capitalize" }
const _hoisted_15 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_16 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_17 = { class: "flex flex-wrap gap-4 py-6" }

import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";

import DefaultButton from "@/components/DefaultButton.vue";
import RouterButton from "@/components/RouterButton.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import RoleGuard from "@/components/RoleGuard.vue";

import api from "@/api/api";
import { Discount } from "@/types";
import { useGlobalStore } from "@/store";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";
import { userHasRole } from "@/utils/roles";



export default /*#__PURE__*/_defineComponent({
  __name: 'DiscountPage',
  async setup(__props) {

let __temp: any, __restore: any

const { t: $t } = useI18n();
const router = useRouter();
const route = useRoute();
const globalStore = useGlobalStore();

const isLoading = ref(false);
const isDeleteConfirmationOpen = ref(false);
const canDelete = ref(false);

const { user_roles } = storeToRefs(globalStore);

const discount = ref({} as Discount);

async function archiveDiscount() {
  try {
    await api.discounts.archiveDiscount(discount.value.id);

    globalStore.toast("SUCCESS", $t("discount-archived"));
    discount.value.archived = true;
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", $t("error-archiving-discount"));
  } finally {
    isLoading.value = false;
  }
}

async function unarchiveDiscount() {
  try {
    isLoading.value = true;

    await api.discounts.unarchiveDiscount(discount.value.id);

    globalStore.toast("SUCCESS", $t("discount-unarchived"));
    discount.value.archived = false;
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", $t("error-unarchiving-discount"));
  } finally {
    isLoading.value = false;
  }
}

async function deleteDiscount() {
  try {
    isLoading.value = true;

    await api.discounts.deleteDiscount(discount.value.id);

    globalStore.toast("SUCCESS", $t("discount-deleted"));
    return router.push({ name: "Discounts" });
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", $t("error-deleting-discount"));
  } finally {
    isLoading.value = false;
  }
}

async function checkCanDelete() {
  try {
    const response = await api.discounts.canDeleteDiscount(discount.value.id);
    canDelete.value = response.data.canDelete;
  } catch (e) {
    console.log("ERROR", e);
  }
}


try {
  discount.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.discounts.getDiscount(String(route.params.id)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.discount;
  // If user is admin admin or courses-admin, check if template can be deleted
    if (userHasRole(user_roles.value, ["admin", "courses-admin"])) {
    (
  ([__temp,__restore] = _withAsyncContext(() => checkCanDelete())),
  await __temp,
  __restore()
);
  }
} catch (e) {
  window.location.href = "/error";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _unref($t)('discount')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref($t)("discount-details")), 1),
          _createVNode(ListRowItem, {
            title: _unref($t)('name')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(discount.value.name), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _unref($t)('code')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, _toDisplayString(discount.value.code), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _unref($t)('renewal-only')
          }, {
            default: _withCtx(() => [
              (discount.value.renewal_only)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "True"))
                : _createCommentVNode("", true),
              (!discount.value.renewal_only)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "False"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _unref($t)('merchant-name')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_8, _toDisplayString(discount.value.merchant_name), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          (discount.value.merchant_name === '2checkout')
            ? (_openBlock(), _createBlock(ListRowItem, {
                key: 0,
                title: _unref($t)('verifone-product-code')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(discount.value.verifone_product_code), 1)
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          _createVNode(ListRowItem, {
            title: _unref($t)('percent-off')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_10, _toDisplayString(Intl.NumberFormat().format(discount.value.percent_amount)) + "%", 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _unref($t)('event-tag')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_11, _toDisplayString(discount.value.tag ? discount.value.tag.name : ""), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _unref($t)('expires-at')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_12, _toDisplayString(new Date(discount.value.expires_at).toDateString()), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _unref($t)('limit-total-uses')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_13, _toDisplayString(discount.value.limit), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _unref($t)('status')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                (discount.value.active)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref($t)("active")), 1))
                  : _createCommentVNode("", true),
                (!discount.value.active)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref($t)("inactive")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(RouterButton, {
            type: "primary",
            to: { name: 'Edit_Discount', params: { id: discount.value.id } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)("edit-discount")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          (!discount.value.archived)
            ? (_openBlock(), _createBlock(RoleGuard, {
                key: 0,
                roles: ['admin', 'courses-admin']
              }, {
                default: _withCtx(() => [
                  _createVNode(DefaultButton, {
                    type: "danger",
                    onAction: archiveDiscount,
                    loading: isLoading.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($t)("archive-discount")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (discount.value.archived)
            ? (_openBlock(), _createBlock(RoleGuard, {
                key: 1,
                roles: ['admin', 'courses-admin']
              }, {
                default: _withCtx(() => [
                  _createVNode(DefaultButton, {
                    type: "danger",
                    onAction: unarchiveDiscount,
                    loading: isLoading.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($t)("unarchive-discount")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
            default: _withCtx(() => [
              _createVNode(DefaultButton, {
                type: "danger",
                class: _normalizeClass([!canDelete.value ? 'cursor-not-allowed !border-gray-600 !bg-gray-600 !hover:bg-gray-600 !hover:border-gray-600' : '']),
                onAction: _cache[0] || (_cache[0] = ($event: any) => (isDeleteConfirmationOpen.value = true)),
                loading: isLoading.value,
                disabled: !canDelete.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)("delete-discount")), 1)
                ]),
                _: 1
              }, 8, ["class", "loading", "disabled"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(ConfirmationModal, {
        buttonText: "Delete Discount",
        class: "danger",
        isOpen: isDeleteConfirmationOpen.value,
        onDelete: deleteDiscount,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (isDeleteConfirmationOpen.value = false))
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_unref($t)("delete-discount-confirmation")), 1)
        ]),
        _: 1
      }, 8, ["isOpen"])
    ])
  ], 64))
}
}

})